module.exports = "<p>\r\n  comment-item works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/comment-item/comment-item.component.html
// module id = ./src/app/shared/components/comment-item/comment-item.component.html
// module chunks = main